/** The Rulebook picker's source tabs: the user's own Rulebooks or public ones. */
var RulebookPickerTab;
(function (RulebookPickerTab) {
    RulebookPickerTab["Mine"] = "mine";
    RulebookPickerTab["Discover"] = "discover";
})(RulebookPickerTab || (RulebookPickerTab = {}));
export default RulebookPickerTab;
